// Related products JS placeholder.
(() => {
  const el = document.querySelector(".c-product-related");
  if (!el) return;
})();

